import React, { useEffect, useState } from 'react'
import './GradeBook.css'
import BarChart from '../Charts/BarChart';
import Marquee from 'react-fast-marquee';
import { useStateValue } from '../../Reducer/reducer';
import { getTotalTime, getAllInprogressCourses, getAllCompletedCourses, getAllInCompletesCourses } from '../Login/sessionService';
import { CaretRightOutlined } from '@ant-design/icons';
import { Alert, Row, Col, Card, Button, Progress, Collapse, theme, Modal } from 'antd';
import DailyLoginTimeChart from '../Charts/DailyLoginTimeChart';
import axios from 'axios';
import { AssesmentUrl } from '../Constants/Constants';
import BookIcon from '@mui/icons-material/Book';
import LeaderboardIcon from '@mui/icons-material/Leaderboard';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import PendingIcon from '@mui/icons-material/Pending';
import CancelIcon from '@mui/icons-material/Cancel';

const GradeBook = () => {
    const { token } = theme.useToken();
    const [TotalTime, setTotalTime] = useState('')
    const [CompletedCourses, setCompletedCourses] = useState('')
    const [inCompletesCourses, setInCompletesCourses] = useState('')
    const [inProgressCourses, setinProgressCourses] = useState('')
    const [Data, setData] = useState([])
    const [
        { IsAuthenticated, UserID },
        dispatch,
    ] = useStateValue();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const showModal = () => {
        setIsModalOpen(true);
    };
    const handleOk = () => {
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        setIsModalOpen(false);
    };
    const panelStyle = {
        marginBottom: 24,
        background: token.colorFillAlter,
        borderRadius: token.borderRadiusLG,
        border: 'none',
    };

    const data = [
        { type: 'You', marks: 38 },
        { type: 'Median', marks: 52 },
        { type: 'Max', marks: 61 },
    ];

    useEffect(() => {
        (async () => {
            const time = await getTotalTime(UserID);
            const completedResponse = await getAllCompletedCourses(UserID)
            const inprogressResponse = await getAllInprogressCourses(UserID)
            const incompleteResponse = await getAllInCompletesCourses(UserID)

            // Extract the actual data from response objects
            // Handle different response structures: direct value, nested data, or full response object
            const getValue = (response) => {
                if (response === null || response === undefined) return 0;
                if (typeof response === 'number' || typeof response === 'string') return response;
                if (response?.data !== undefined) {
                    const data = response.data;
                    if (typeof data === 'number' || typeof data === 'string') return data;
                    if (data?.data !== undefined) return data.data;
                }
                return 0;
            };

            const completedCount = getValue(completedResponse);
            const inprogressCount = getValue(inprogressResponse);
            const incompleteCount = getValue(incompleteResponse);

            setCompletedCourses(completedCount)
            setInCompletesCourses(incompleteCount)
            console.log(completedCount, "CompletedCourses")
            setinProgressCourses(inprogressCount)
            setTotalTime(time || '0');
        })();
    }, [UserID]);

    useEffect(() => {
        let body = {
            user_id: UserID
        }
        axios
            .post(`${AssesmentUrl}get_user_report`, body)
            .then((res) => {
                console.log(res)
                // Extract user_score_report from response - handle both direct data and nested data structure
                const reportData = res.data?.data?.user_score_report || res.data?.user_score_report || [];
                
                if (!Array.isArray(reportData) || reportData.length === 0) {
                    setData([]);
                    return;
                }

                console.log(reportData[0]?.assessments, "dataaa")
                let arr = []
                for (let index = 0; index < reportData.length; index++) {
                    let i = reportData[index]
                    if (!i || !i.AssessmentName || !i.CourseName) {
                        continue; // Skip invalid items
                    }
                    let obj = {
                        key: index + 1,
                        label: <div> <p className='CollapseH1'> Completed {i.AssessmentName}</p>
                            <h4 style={{ margin: 0 }}>{i.CourseName}</h4>
                        </div>,
                        children: <>
                            <Card className='gradebookChartCard'>
                                <h3 className='gradebookChartTitle'>
                                    You vs your Batch
                                </h3>
                                <BarChart data={i.assessments || []} />
                            </Card>
                        </>,
                        style: panelStyle,
                    }
                    arr.push(obj)
                }
                setData(arr)
                console.log(arr, "array")
            })
            .catch((err) => {
                console.log(err)
                setData([]); // Set empty array on error
            })
    }, [UserID])


    return (
        <div className='gradebookMain'>
            <Modal 
                title="Daily Average Usage" 
                footer={false} 
                open={isModalOpen} 
                onOk={handleOk} 
                onCancel={handleCancel}
                className='gradebookModal'
            >
                <DailyLoginTimeChart userId={UserID} />
            </Modal>

            {/* Header Section */}
            <div className='gradebookHeader'>
                <div className='gradebookHeaderContent'>
                    <BookIcon className='gradebookHeaderIcon' />
                    <h1 className='gradebookTitle'>Gradebook</h1>
                </div>
                <Alert
                    banner
                    message={
                        <Marquee pauseOnHover gradient={false}>
                            Any changes in the assessment grades will be updated in the Gradebook after 24 hours.
                        </Marquee>
                    }
                    className='gradebookAlert'
                />
            </div>

            {/* Stats Cards Section */}
            <div className='gradebookStatsGrid'>
                {/* Course Progress Card */}
                <Card className='gradebookCard courseProgressCard'>
                    <div className='gradebookCardHeader'>
                        <div className='gradebookCardIconWrapper'>
                            <BookIcon className='gradebookCardIcon' />
                        </div>
                        <div className='gradebookCardTitleWrapper'>
                            <h3 className='gradebookCardTitle'>Course Progress</h3>
                            <img className='comingSoonBadge' src='/icons/coming-soon-1.png' alt='coming soon' width={24} height={24} />
                        </div>
                    </div>
                    <div className='gradebookCardContent'>
                        <div className='courseProgressItem'>
                            <div className='courseProgressItemIcon inProgress'>
                                <PendingIcon />
                            </div>
                            <div className='courseProgressItemInfo'>
                                <p className='courseProgressItemLabel'>In Progress</p>
                                <h3 className='courseProgressItemValue'>
                                    {typeof inProgressCourses === 'object' ? '-' : (inProgressCourses || '-')}
                                </h3>
                            </div>
                        </div>
                        <div className='courseProgressItem'>
                            <div className='courseProgressItemIcon completed'>
                                <CheckCircleIcon />
                            </div>
                            <div className='courseProgressItemInfo'>
                                <p className='courseProgressItemLabel'>Completed</p>
                                <h3 className='courseProgressItemValue'>
                                    {typeof CompletedCourses === 'object' ? '-' : (CompletedCourses || '-')}
                                </h3>
                            </div>
                        </div>
                        <div className='courseProgressItem'>
                            <div className='courseProgressItemIcon incomplete'>
                                <CancelIcon />
                            </div>
                            <div className='courseProgressItemInfo'>
                                <p className='courseProgressItemLabel'>Incomplete</p>
                                <h3 className='courseProgressItemValue'>
                                    {typeof inCompletesCourses === 'object' ? '-' : (inCompletesCourses || '-')}
                                </h3>
                            </div>
                        </div>
                    </div>
                </Card>

                {/* Leaderboard Card */}
                <Card className='gradebookCard leaderboardCard'>
                    <div className='gradebookCardHeader'>
                        <div className='gradebookCardIconWrapper'>
                            <LeaderboardIcon className='gradebookCardIcon' />
                        </div>
                        <div className='gradebookCardTitleWrapper'>
                            <h3 className='gradebookCardTitle'>Leaderboard</h3>
                            <img className='comingSoonBadge' src='/icons/coming-soon-1.png' alt='coming soon' width={24} height={24} />
                        </div>
                    </div>
                    <div className='gradebookCardContent'>
                        <div className='leaderboardStats'>
                            <div className='leaderboardStatItem'>
                                <p className='leaderboardStatLabel'>Your Points</p>
                                <h3 className='leaderboardStatValue'>-</h3>
                            </div>
                            <div className='leaderboardStatItem'>
                                <p className='leaderboardStatLabel'>Total Time</p>
                                <h3 className='leaderboardStatValue'>
                                    {typeof TotalTime === 'object' ? '-' : (TotalTime || '-')}
                                </h3>
                            </div>
                        </div>
                        <Button className='leaderboardButton' type='link' size='small'>
                            View Leaderboard
                        </Button>
                    </div>
                </Card>

                {/* Timeline Card */}
                <Card className='gradebookCard timelineCard'>
                    <div className='gradebookCardHeader'>
                        <div className='gradebookCardIconWrapper'>
                            <AccessTimeIcon className='gradebookCardIcon' />
                        </div>
                        <div className='gradebookCardTitleWrapper'>
                            <h3 className='gradebookCardTitle'>Timeline</h3>
                            <img className='comingSoonBadge' src='/icons/coming-soon-1.png' alt='coming soon' width={24} height={24} />
                        </div>
                    </div>
                    <div className='gradebookCardContent'>
                        <div className='timelineStatItem'>
                            <p className='timelineStatLabel'>Today's Logged Time</p>
                            <h3 className='timelineStatValue'>-</h3>
                        </div>
                        <Button
                            className='timelineButton'
                            type='link'
                            size='small'
                            disabled
                        >
                            View Timeline
                        </Button>
                    </div>
                </Card>
            </div>

            {/* Assessment Results Section */}
            <div className='gradebookAssessments'>
                <h2 className='gradebookAssessmentsTitle'>Assessment Results</h2>
                <Collapse
                    bordered={false}
                    expandIcon={({ isActive }) => <CaretRightOutlined rotate={isActive ? 90 : 0} className='gradebookCollapseIcon' />}
                    className='gradebookCollapse'
                    items={Data}
                />
            </div>
        </div>
    )
}

export default GradeBook



